<template>
  <div class="hzal">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd bxz">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox">
      <div class="lbBoxtext">
        <div class="lbBoxtexts lbBoxtext1">百种营销玩法</div>
        <div class="lbBoxtexts lbBoxtext2">有效落地助力商家提升成交裂变</div>
      </div>
    </div>
    <div class="tabsboxbox">
      <div class="tabsbox">
        <van-tabs
          style="width: 12rem; margin: 0 auto"
          v-model="active"
          title-active-color="#2D66FC"
          title-inactive-color="#1E1E1E"
          color="#2D66FC"
        >
          <van-tab title="全部"></van-tab>
          <van-tab title="餐饮行业案例"></van-tab>
          <van-tab title="服务行业案例"></van-tab>
          <van-tab title="建材家居行业案例"></van-tab>
          <van-tab title="美容养生行业案例"></van-tab>
          <van-tab title="爆品营销案例"></van-tab>
          <van-tab title="教育市场案例"></van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="inboxbox">
      <div class="inbox" v-if="active == 0">
        <div class="hzfa1boxbox">
          <div @click="alxq1" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">平台赋能面馆活动引爆营销</div>
              <div class="hzfa1text2">
                当今时代挣钱不易，打工对于大多数人来说可能一辈子挣不了多少钱，只能解决基本问题。相信很多朋友有创业的想法，餐饮业是一个很好的选择，而开一个面馆，成本较低，盈利也不错，是很多创业者的选择。
                <br />

                今天米创科技跟大家介绍一家面馆的案例。这个面馆开在一个写字楼的旁边，离写字楼近，升级装修后，装的很用心，总共设有70多个座位，算是比较大的面馆了，当然不仅仅是做面，还有很多配菜、酒水之类的。
              </div>
            </div>
          </div>
          <div @click="alxq2" class="hzfa1boxboxs">
            <div class="hzfa1text">
              <div class="hzfa1text1">饺子馆会员制简单有效促使精准回流</div>
              <div class="hzfa1text2">
                会员制是商业模式中经常会用到的一种模式,简单有效的就能回流精准客户,比如充1000送1500,其中包括1000卡内储值,以及1500元的礼品。
                <br />
                对于餐饮行业来说，这样的优惠力度,客户一看见就会被牢牢的吸引,因为,这时候客户看待这个优惠宣传不是一种花钱的心理,而是挣钱的心态。
                <br />
                设计“"赠品+会员卡"的营销套路,一定要计算好成本,要计算到即使客户天天一个人来消费,也不会出现赔本的情況;计算赠采购支出在整个营销成本中的占比,是否会出现亏损的情况,这样才能保证整个活动正常实施整体活动方案要按照“引流+截流+回流+现金流”的闭环模式设计。
              </div>
            </div>
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
          </div>
          <div @click="alxq3" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">健身俱乐部引流锁客经典案例</div>
              <div class="hzfa1text2">
                某健身俱乐部成立于2016年年初，是当地仅有的一家健身俱乐部，占地1200平方，投资200万元，专业教练15余名。健身俱乐部内部的装修在健身馆中属于一般，不仅内部装修宜人，健身设备完善，而且健身馆内的可选课程也相当丰富。
                <br />
                但是，健身馆一直面临客户流失问题——锁客环节薄弱。因此，米创科技为其设计了“0元健身”的活动，帮助其引流锁客。此次活动不仅解决锁客难的问题，还使健身馆的月营业额显著提升！
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inbox" v-if="active == 1">
        <div class="hzfa1boxbox">
          <div @click="alxq1" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">平台赋能面馆活动引爆营销</div>
              <div class="hzfa1text2">
                当今时代挣钱不易，打工对于大多数人来说可能一辈子挣不了多少钱，只能解决基本问题。相信很多朋友有创业的想法，餐饮业是一个很好的选择，而开一个面馆，成本较低，盈利也不错，是很多创业者的选择。
                <br />

                今天米创科技跟大家介绍一家面馆的案例。这个面馆开在一个写字楼的旁边，离写字楼近，升级装修后，装的很用心，总共设有70多个座位，算是比较大的面馆了，当然不仅仅是做面，还有很多配菜、酒水之类的。
              </div>
            </div>
          </div>
          <div @click="alxq2" class="hzfa1boxboxs">
            <div class="hzfa1text">
              <div class="hzfa1text1">饺子馆会员制简单有效促使精准回流</div>
              <div class="hzfa1text2">
                会员制是商业模式中经常会用到的一种模式,简单有效的就能回流精准客户,比如充1000送1500,其中包括1000卡内储值,以及1500元的礼品。
                <br />
                对于餐饮行业来说，这样的优惠力度,客户一看见就会被牢牢的吸引,因为,这时候客户看待这个优惠宣传不是一种花钱的心理,而是挣钱的心态。
                <br />
                设计“"赠品+会员卡"的营销套路,一定要计算好成本,要计算到即使客户天天一个人来消费,也不会出现赔本的情況;计算赠采购支出在整个营销成本中的占比,是否会出现亏损的情况,这样才能保证整个活动正常实施整体活动方案要按照“引流+截流+回流+现金流”的闭环模式设计。
              </div>
            </div>
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
          </div>
           <div @click="alxq6" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">餐饮难做？这招用过，储值轻松翻倍！</div>
              <div class="hzfa1text2">
               
              我国整体餐饮市场在业态、质量、价位等多方面发展不平衡，产业集中度不高、人均餐饮餐饮消费水平低，且市场份额分散程度极高。最重要的原因就是餐饮行业门槛低，市场竞争异常激烈。
              
                <br />

               

              而餐饮行业从业者若想打破这一困局，从众多同行竞争者中脱颖而出，除了自身的管理，还有一个最有效最简单的操作模式———充值会员卡。
            
              </div>
            </div>
          </div>
          <div @click="alxq7" class="hzfa1boxboxs">
            <div class="hzfa1text">
              <div class="hzfa1text1">
              餐饮业绩是否翻倍，就看这五大活动是否执行！
            </div>
              <div class="hzfa1text2">
                
              回归餐饮市场，我们整理了现今中国经济消费结构基础下，餐饮行业的几大痛点如下：
              
                <br />
             
              1、餐饮市场分散
              
                <br />
                
              2、专业人才培养不足
              
             <br />
                  
              3、连锁餐饮业标准化程度较低
              
       <br />
                 
              4、餐饮企业利润空间小
              
        <br />
                 
              5、食品安全监管更加严格
              
              <br />
            
              如何解决这5大问题，找对方法即可快速破局。
              
              
             <br />
               
              而餐饮行业从业者若想打破这一困局，从众多同行竞争者中脱颖而出，除了自身的管理，还要从营销角度上看，这些问题其实可以总结成以下四问题：引流难 截留难 资金回流难
              裂变复购难。这四个营销问题解决了，您的餐饮门店业绩的翻倍的实现也就不远了。
 </div>

            </div>
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
          </div>
           <div @click="alxq8" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">餐饮专属|爆品营销策略助力生意火爆</div>
              <div class="hzfa1text2">
                
              夏季来临，尤其是炎热的北方，高温多雨的天气会让很多餐饮店铺受影响，尤其是串串、火锅等有明显季节性淡季的品类。
              
                <br />

               在这样的情况下，如果想在炎炎夏日让生意像温度一样“火爆”，可以考虑以下几单品作为爆品营销的产品素材。
               <br />

              这几款产品均为
              上下即可采购的酒水，涵盖两大重要的品类：葡萄酒和白酒。同时，品牌和系列也均选择茅台集团、五粮液股份、白马歌德系列等有高影响力的产品，可以起到
                <br />
              快速吸引消费者眼球+参与活动 的效果。
            
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inbox" v-if="active == 2">
        <div class="hzfa1boxbox">
          <div @click="alxq3" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">健身俱乐部引流锁客经典案例</div>
              <div class="hzfa1text2">
                某健身俱乐部成立于2016年年初，是当地仅有的一家健身俱乐部，占地1200平方，投资200万元，专业教练15余名。健身俱乐部内部的装修在健身馆中属于一般，不仅内部装修宜人，健身设备完善，而且健身馆内的可选课程也相当丰富。
                <br />

                但是，健身馆一直面临客户流失问题——锁客环节薄弱。因此，米创科技为其设计了“0元健身”的活动，帮助其引流锁客。此次活动不仅解决锁客难的问题，还使健身馆的月营业额显著提升！
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inbox" v-if="active == 3">
        <div class="hzfa1boxbox">
          <div @click="alxq4" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">
                卫浴店借助积分商城，通过社群营销月销售额增长3倍！
              </div>
              <div class="hzfa1text2">
                有一家卫浴店，开业后因为疫情原因，门店销售迟迟没有起色，后来在朋友的推荐下，加入了米创科技。通过学习营销课程，借用平台积分，在短短1个月，销售报增3倍。
                <br />

                在营销导师的指点下，老板在引流上做了这样一个活动。他首先找到正在交房装修的小区，联系到业主群。然后和群主谈合作。只要群主成功在业主群内拼单满10单以上，参与拼团的用户每人一律奖励1000平台积分（可兑换小家电、炒锅、家纺、品牌食用油等）。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inbox" v-if="active == 4">
        <div class="hzfa1boxbox">
          <div @click="alxq5" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">
                用2个步骤，一周新增628客户，营收91万！
              </div>
              <div class="hzfa1text2">
                现在，人均收入不断增加，国家经济水平不断提升，人们对美的需求越来越旺盛，于是美容养生行业很多人都很看好，并投身其中。
                <br />

                但随着移动互联的不断发展，大家的消费理念和行为都发生了很大变化，经营美容养生馆也需要改变思路，跟上时代的步伐，采用一些合适的方法和策略，否则很容易被时代抛弃而面临倒闭。
                <br />
                今天米创科技给大家介绍一家美容养生馆的案例，希望能给大家一些参考。
              </div>
            </div>
          </div>
           <div @click="alxq9" class="hzfa1boxboxs">
            <div class="hzfa1text">
              <div class="hzfa1text1">
              美容行业专属|爆品营销助力拓客引流，这样做流量暴涨，营业额翻倍。
            </div>
              <div class="hzfa1text2">
                拓新客难是美容行业共同、最大的痛点，其根本原因有两个。
              
                <br />
               1、行业竞争大。 一条商业街或一个热门商圈，往往有三五个医美整形、七八个美容院和数不胜数的美甲场所，但因消费者地域属性的限制，真正的消费用户总体是有限的。
              
                <br />
               2、客户粘性低。 竞争大的大背景下，各门店都积极用优惠吸引客户，免费体验、转发送礼、月卡季卡等等活动“一望无尽”，在此基础上，培养客户的忠诚度的重要性就又被抬上新的高度。
            
              </div>
            </div>
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inbox" v-if="active == 5">
        <div class="hzfa1boxbox">
          <div @click="alxq11" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">
              
              爆品营销|萌宠店储值怎么做？看完恍然大悟
            
            </div>
              <div class="hzfa1text2">
               
              
              随着萌宠经济的爆发式增长，养宠物的人越来越多，养宠物的品类也越来越丰富。而随之而来的也有宠物店越开越多，开得多但关得也多。
              
              
                <br />

               

              

              今天介绍为萌宠店打造的爆品营销活动：只需20天，新客引流+储值即可达到超乎意料的效果。
            
            
            
              </div>
            </div>
          </div>
          <div @click="alxq12" class="hzfa1boxboxs">
            <div class="hzfa1text">
              <div class="hzfa1text1">
              爆品营销|连锁酒店锁客成交方案，做好引流能达85%！
            
            </div>
              <div class="hzfa1text2">
                
              酒店遍布于各商贸圈，所处地带一般人流大，竞争也大，尤其是100-200 元中低端价位的酒店，不打价格战口碑很难上去。
              
              
              
                <br />
             新客户流失率大是绝大部分酒店尤其是连锁酒店的痛点。
              
              
                <br />
               
              针对这些痛点，可以在特殊节日举办
              
              </div>
            </div>
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
          </div>
          <div @click="alxq13" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">
              爆品营销|汽修行业如何周转现金流？这样做更能锁客吸金！</div>
              <div class="hzfa1text2">
                米创官方服务中心  1周前
                <br />
                
              汽修店较其他行业店铺 开店周期长，增长慢回本慢，虽风险低但资金流转相对艰难
              <br />
              
              根据行业痛点，可以选择这样做。
             
              </div>
            </div>
          </div>
          <!--  -->
          <div @click="alxq14" class="hzfa1boxboxs">
            <div class="hzfa1text">
              <div class="hzfa1text1">饺子馆会员制简单有效促使精准回流</div>
              <div class="hzfa1text2">
                会员制是商业模式中经常会用到的一种模式,简单有效的就能回流精准客户,比如充1000送1500,其中包括1000卡内储值,以及1500元的礼品。
                <br />
                对于餐饮行业来说，这样的优惠力度,客户一看见就会被牢牢的吸引,因为,这时候客户看待这个优惠宣传不是一种花钱的心理,而是挣钱的心态。
                <br />
                设计“"赠品+会员卡"的营销套路,一定要计算好成本,要计算到即使客户天天一个人来消费,也不会出现赔本的情況;计算赠采购支出在整个营销成本中的占比,是否会出现亏损的情况,这样才能保证整个活动正常实施整体活动方案要按照“引流+截流+回流+现金流”的闭环模式设计。
              </div>
            </div>
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
          </div>
          <div @click="alxq15" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">
              直面汽修行业痛点。这样储值一周超七位数
            </div>
              <div class="hzfa1text2">
               
              目前在我国的汽修市场上有以下几大痛点：
              
                <br />
                
              1、渠道有限，企业难生存<br />
                
             
              2、库存积压，规划捋不清
              <br />
                
             
              3、眼光长远，实操难布局
              <br />
                
             
              4、能力有限，团队难管理
              <br />
                
             
              5、缺少监督，员工难掌控
              <br />
                
             
              如何解决这5大问题，找对方法即可快速破局。
            
              
              </div>
            </div>
          </div>
          <div @click="alxq16" class="hzfa1boxboxs">
            <div class="hzfa1text">
              <div class="hzfa1text1">
              学生季丨爆品营销必备：假期/开学必备好物
            </div>
              <div class="hzfa1text2">
                
              假期已全面开始，作为线下商家的你，有没有为此精心做准备呢？消费频次高、单价高的
              
                <br />
               
             
              属性，该节点采用爆品营销方案引流客户，或能产生不错的效果。
              
 </div>
            </div>
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
      <div class="inbox" v-if="active == 6">
        <div class="hzfa1boxbox">
          <div @click="alxq10" class="hzfa1boxboxs">
            <div class="hzfa1box">
              <div class="hzfa1img">
                <img class="img" src="../../assets/images/1415.png" alt="" />
              </div>
            </div>
            <div class="hzfa1text">
              <div class="hzfa1text1">
               
              教培市场落地营销方案
            
              </div>
              <div class="hzfa1text2">
               
              爆品商城，是米创科技旗下重要的服务商家的工具。其功能为提供商家端爆品采购
              
                <br />
              今天，推荐的爆品营销方案主要针对教培市场
              
                <br />
               
              高考已于月初结束，中考也已于近日落下帷幕。身处教培市场的你，是否在为暑假招生引流发愁呢？
                <br />
                对于教培机构来说，招生
                是最重要的事情。毕竟同行竞争加剧，且各机构提供的服务相差都不多，再加之国家对教培市场整体的规范，综合下来，会导致招生一如既往没有头绪，营销活动可能也不痛不痒。
                为了解决“为营销而营销”的老大难为题，今天给大家讲解一组爆品商城的落地营销方案，无论处于教培市场上的哪一环，是教培市场上的哪类机构，均可直接复制。


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tijiaoboxbox">
      <div class="tijiaobox">
        <div class="biaoti">营销落地 顺势而为</div>
        <div class="biaogebox">
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="姓名"
              id="txt"
              value=""
              ref="name1"
              v-on:keyup="inputRef1"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="手机"
              id="txt"
              value=""
              ref="name2"
              v-on:keyup="inputRef2"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="公司名称"
              id="txt"
              value=""
              ref="name3"
              v-on:keyup="inputRef3"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="省份"
              id="txt"
              value=""
              ref="name4"
              v-on:keyup="inputRef4"
            />
          </div>
        </div>
        <div class="tijiaobtn" @click="ziliao()">立即申请</div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk:1,

    };
  },
  mounted() {},
  methods: {
    inputRef1: function () {
      console.log(this.$refs.name1.value);
      this.name1 = this.$refs.name1.value;
    },
    inputRef2: function () {
      console.log(this.$refs.name2.value);
      this.name2 = this.$refs.name2.value;
    },
    inputRef3: function () {
      console.log(this.$refs.name3.value);
      this.name3 = this.$refs.name3.value;
    },
    inputRef4: function () {
      console.log(this.$refs.name4.value);
      this.name4 = this.$refs.name4.value;
    },
    ziliao() {
      console.log(this.name1);
      console.log(this.name2);
      console.log(this.name3);
      console.log(this.name4);
      if (
        this.name1 == "" ||
        this.name1 == "name1" ||
        this.name1 == undefined
      ) {
        this.$toast("请输入您的姓名");
      } else if (
        this.name2 == "" ||
        this.name2 == "name2" ||
        this.name2 == undefined
      ) {
        this.$toast("请输入您的手机号");
      } else if (
        this.name3 == "" ||
        this.name3 == "name3" ||
        this.name3 == undefined
      ) {
        this.$toast("请输入您的公司名称");
      } else if (
        this.name4 == "" ||
        this.name4 == "name4" ||
        this.name4 == undefined
      ) {
        this.$toast("请输入您的省份");
      } else {
        this.tech_www();
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
    alxq() {
      this.$router.push({
        path: "/alxq",
      });
    },
    alxq1() {
      this.$router.push({
        path: "/alxq1",
      });
    },
    alxq2() {
      this.$router.push({
        path: "/alxq2",
      });
    },
    alxq3() {
      this.$router.push({
        path: "/alxq3",
      });
    },
    alxq4() {
      this.$router.push({
        path: "/alxq4",
      });
    },
    alxq5() {
      this.$router.push({
        path: "/alxq5",
      });
    },
    // 
    // 
    // 
    alxq6() {
      this.$router.push({
        path: "/alxq6",
      });
    },
    alxq7() {
      this.$router.push({
        path: "/alxq7",
      });
    },
    alxq8() {
      this.$router.push({
        path: "/alxq8",
      });
    },
    alxq9() {
      this.$router.push({
        path: "/alxq9",
      });
    },
    alxq10() {
      this.$router.push({
        path: "/alxq10",
      });
    },
    alxq11() {
      this.$router.push({
        path: "/alxq11",
      });
    },
    alxq12() {
      this.$router.push({
        path: "/alxq12",
      });
    },
    alxq13() {
      this.$router.push({
        path: "/alxq13",
      });
    },
    alxq14() {
      this.$router.push({
        path: "/alxq14",
      });
    },
    alxq15() {
      this.$router.push({
        path: "/alxq15",
      });
    },
    alxq16() {
      this.$router.push({
        path: "/alxq16",
      });
    },
    // 数据提交
    tech_www() {
      let form_data = new FormData();
      // 姓名
      form_data.append("name", this.name1);
      // 电话
      form_data.append("jobs", this.name2);
      // 需求
      form_data.append("company", this.name3);
      // 省份
      form_data.append("province", this.name4);
      // // 身份证反面照片
      // form_data.append("idcardReversePhoto", this.idcardReversePhoto);

      API.tech_www(form_data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          // this.typeofwork = res.data.dicList;
          // this.$router.push({
          //   path: "/success"
          // });
          this.$toast(res.data.msg);
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.hzal {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    background: none;
    .logo {
      background: url("../../assets/images/123213.png");
    }
    .cdBox {
      .cd {
        color: #000;
      }
      .cd:hover {
        border-bottom: 2px solid #000000;
      }
      .bxz {
        border-bottom: 2px solid #000;
      }
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1397.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
    padding-top: 2.19rem;
    box-sizing: border-box;
    .lbBoxtext {
      width: 1200px;
      margin: 0 auto;
      .lbBoxtexts {
        text-align: left;
      }
      .lbBoxtext1 {
        font-size: 0.6rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #232323;
        margin-bottom: 0.4rem;
      }
      .lbBoxtext2 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #232323;
        line-height: 0.38rem;
      }
    }
  }
  .tabsboxbox {
    background: #fff;
    margin-bottom: 0.1rem;
    .tabsbox {
      // width: 1200px;
      box-shadow: 0rem 0rem 0.14rem 0rem rgba(0, 0, 0, 0.16);
      margin-bottom: 0.1rem;
      margin: 0 auto;
      .van-tabs__wrap {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // padding-top: 0.1rem;
      }
      .van-tabs__nav {
        width: 12rem;
        display: flex;
        flex-wrap: wrap;
      }
      .van-tab {
        // width: 2rem;
      }
    }
  }
  .inboxbox {
    width: 100%;
    background: #fff;
    .inbox {
      margin: 0 auto;
      width: 1200px;
      padding-top: 1.2rem;
      padding-bottom: 1.3rem;
      .hzfa1boxbox {
        .hzfa1boxboxs {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 1.5rem;
          cursor:pointer;
          .hzfa1box {
            width: 6rem;
            .hzfa1img {
              width: 5.14rem;
              height: 3.11rem;
              // background: url('../../assets/images/');.
              background: #dfe7fa;
              padding-top: 0.14rem;
              .img {
                display: flex;
                width: 5.72rem;
                height: 3.54rem;
                margin-left: 0.14rem;
              }
            }
          }
          .hzfa1text {
            width: 5.8rem;
            height: 3.5rem;
            margin-left: 0.2rem;
            padding-top: 0.44rem;
            box-sizing: border-box;
            background: url("../../assets/images/6354645.png") no-repeat left
              bottom;
            .hzfa1text1 {
              font-size: 0.26rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #232323;
              margin-bottom: 0.35rem;
            }
            .hzfa1text2 {
              font-size: 0.14rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #868686;
              line-height: 0.32rem;
            }
          }
          .hzfa1text:nth-child(2n) {
            padding-right: 0.2rem;
            padding-top: 0.44rem;
          }
        }
        .hzfa1boxboxs:nth-child(2n) {
          margin-bottom: 1rem;
          .hzfa1box {
            width: 6rem;
            .hzfa1img {
              width: 5.14rem;
              height: 3.11rem;
              // background: url('../../assets/images/');.
              background: #dfe7fa;
              padding-top: 0.14rem;
              margin-left: 0.88rem;
              margin-top: 0.7rem;
              position: relative;
              .img {
                display: flex;
                width: 5.72rem;
                height: 3.54rem;
                position: absolute;
                bottom: 0.14rem;
                right: 0.14rem;
              }
            }
          }
          .hzfa1text {
            width: 5.8rem;
            margin-right: 0.2rem;
            padding-top: 0.44rem;
            box-sizing: border-box;
            margin-left: 0;
            background: url("../../assets/images/6354645.png") no-repeat right
              bottom;
            .hzfa1text1 {
              font-size: 0.26rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #232323;
              margin-bottom: 0.35rem;
            }
            .hzfa1text2 {
              font-size: 0.14rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #868686;
              line-height: 0.32rem;
            }
          }
        }
        .hzfa1boxboxs:nth-child(2n-1) {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 1.2rem;
          .hzfa1box {
            width: 6rem;
            .hzfa1img {
              width: 5.14rem;
              height: 3.11rem;
              // background: url('../../assets/images/');.
              background: #dfe7fa;
              padding-top: 0.14rem;
              .img {
                display: flex;
                width: 5.72rem;
                height: 3.54rem;
                margin-left: 0.14rem;
              }
            }
          }
          .hzfa1text {
            width: 5.8rem;
            margin-left: 0.2rem;
            padding-top: 0.44rem;
            box-sizing: border-box;
            background: url("../../assets/images/6354645.png") no-repeat left
              bottom;
            .hzfa1text1 {
              font-size: 0.26rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #232323;
              margin-bottom: 0.35rem;
            }
            .hzfa1text2 {
              font-size: 0.14rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #868686;
              line-height: 0.32rem;
            }
          }
          .hzfa1text:nth-child(2n) {
            padding-right: 0.2rem;
            padding-top: 0.44rem;
          }
        }
      }
    }
  }
  .gootbox {
    width: 100%;
    height: 5.32rem;
    background: #fbfbfb;
    .goot {
      width: 1740px;
      margin: 0 auto;
      .top {
        height: 1rem;
        display: flex;
        justify-content: left;
        align-items: center;
        border-bottom: 1px solid #eaeaea;
        margin-bottom: 0.3rem;
        .text {
          font-size: 0.25rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #5f6364;
          margin-right: 0.6rem;
        }
        .img {
          width: 0.32rem;
          height: 0.32rem;
          margin-right: 0.49rem;
        }
        .img1 {
          background: url("../../assets/images/wx1.png");
        }
        .img1:hover {
          background: url("../../assets/images/wx2.png");
        }
        .img2 {
          background: url("../../assets/images/wb1.png");
        }
        .img2:hover {
          background: url("../../assets/images/wb2.png");
        }
      }
      .goot2box {
        height: 3.8rem;
        display: flex;
        .goot2 {
          margin-right: 1.14rem;
          margin-top: 0.3rem;
          .goot2text {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #7f7f7f;
            margin-bottom: 0.2rem;
            cursor: pointer;
          }
          .goot2text:hover {
            color: #2d60fe;
          }
          .goot2text1 {
            font-size: 0.25rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #474747;
            margin-bottom: 0.45rem;
          }
          .goot2text2 {
          }
          .goot2text3 {
          }
          .goot2text4 {
          }
          .goot2text5 {
          }
        }
        .goot2style {
          margin-right: 2.35rem;
        }
        .goot2right {
          width: 3.2rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;  
  padding-top: 0.3rem;
  box-sizing: border-box;
          .img {
            width: 3.04rem;
            height: 0.83rem;
            background: url("../../assets/images/867.png") no-repeat center;
            background-size: 100% 100%;

            // margin-bottom: 0.4rem;
          }
          .textbox {
            // width: 3.11rem;
            height: 1.43rem;
            background: #ffffff;
            border-radius: 20px;
            display: flex;
            .rwm {
              // width: 50%;
              display: flex;
              justify-content: center;
              flex-wrap: wrap;
              padding-top: 0.15rem;
              .img1 {
                width: 0.77rem;
                height: 0.77rem;
                background: url("../../assets/images/85c3e9280f99ad7a53a06a60079ff75.jpg")
                  no-repeat center;
                background-size: 100% 100%;
              }
              .img2 {
                width: 0.77rem;
                height: 0.77rem;
                background: #000;
              }
              .text1 {
                font-size: 0.14rem;
                font-size: 0.2rem;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #191919;
                width: 100%;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .nr1Box {
    width: 100%;
    height: 11.57rem;
    background: url("../../assets/images/ssss.png") no-repeat center;
    background-size: 100% 100%;
    .nr {
      width: 12rem;
      margin: 0 auto;
      display: flex;
      .nrLeft {
        width: 5.5rem;
        margin-top: 2.5rem;
        margin-right: 0.5rem;
        .nrLeftText1 {
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #000000;
          display: flex;
          // justify-content: center;
          align-items: center;
          margin-bottom: 0.3rem;
        }
        .nrLeftText2 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6c6c6c;
          line-height: 38px;
          margin-bottom: 0.3rem;
        }
        .nrLeftText3 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-left: 0.2rem;
        }
        .nrLeftText4 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-left: 1.18rem;
        }
        .nrLeftText4s {
          margin-left: 0.2rem;
          background: #4273fd;
          color: #fff;
        }
        .nrLeftText3 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
        }
        .nrLeftText3s {
          margin-left: 1.44rem;
          background: #4273fd;
          color: #fff;
        }
      }
      .nrLefts {
        margin-right: 0;
      }
      .nrRight {
        width: 5rem;
        margin-left: 1rem;
        margin-top: 0.78rem;
        .img {
          display: block;
          width: 4.56rem;
          height: 9.33rem;
          margin: 0 auto;
        }
      }
      .nrRights {
        margin-left: 0rem;
        margin-top: 0rem;
        margin-right: 1.5rem;
      }
    }
  }
  .ggci {
    width: 100%;
    height: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.34rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    margin-bottom: 0.2rem;
    margin-top: 1rem;
  }
  .gcis {
    width: 100%;
    height: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 0.14rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #868686;

    margin-bottom: 0.2rem;
  }
  .lqdBox {
    width: 100%;
    height: 7.17rem;
    background: url("../../assets/images/188.png") no-repeat center;
    background-size: 100% 100%;
    .lqd {
      width: 1200px;
      padding-top: 1rem;
      box-sizing: border-box;
      margin: 0 auto;
      .text1 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        margin-bottom: 0.97rem;
      }
      .left {
        width: 4.8rem;
        margin-right: 0.8rem;
        .left1 {
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 0.5rem;
        }
        .left2 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #efeeee;
          line-height: 38px;
        }
      }
      .right {
        display: flex;
        margin-left: 0.1rem;
        margin-right: 0.1rem;
        margin-bottom: 0.18rem;
        .right1 {
          width: 3.1rem;
          height: 1.96rem;
          background: #ffffff;
          border-radius: 0.2rem;
          display: flex;
          .right1_left {
            width: 1.5rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .img {
              display: block;
              width: 0.66rem;
              height: 0.66rem;
            }
          }
          .right1_right {
            width: 1.2rem;
            .right1_right_text1 {
              margin-bottom: 0.28rem;
              margin-top: 0.39rem;
            }
          }
        }
      }
    }
  }
  .nr1Boxs {
    background: url("../../assets/images/183.png") no-repeat center;
    background-size: 100% 100%;
    margin-bottom: 1.5rem;
  }
  .tijiaoboxbox {
    width: 100%;
    background: url("../../assets/images/jiao.png") no-repeat center;
    background-size: 100% 100%;
    .tijiaobox {
      width: 1200px;
      height: 4.64rem;
      margin: 0 auto;
      .biaoti {
        font-size: 0.42rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        padding-top: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.9rem;
      }
      .biaogebox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
        .biaoge {
          width: 2.76rem;
          height: 0.42rem;
          background: #ffffff;
          border-radius: 0.1rem;
          margin-left: 0.11rem;
          margin-right: 0.11rem;
          .index {
            width: 100%;
            height: 100%;
            padding-left: 0.2rem;
            box-sizing: border-box;
            border-radius: 0.1rem;
            border: none;
          }
        }
      }
      .tijiaobtn {
        width: 1.62rem;
        height: 0.5rem;
        border: 0.02rem solid #ffffff;
        border-radius: 0.1rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/hzal/index.vue